import React from 'react';
import {
    DataGrid,
    esES,
} from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { GridActionsCellItem } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import ComprobantePrint from './ComprobantePrint';
import { comprobantesPrintData } from "src/projects/gestion_documental/helpers/ComprobantesData";
import { SimpleDialogComponent } from 'src/general_components/SimpleDialogComponent';

export const ComprobantesTable = ({ data }) => {

    console.log("data", data);
    const [modalState, setModalState] = React.useState(false);
    const [childModal, setChildModal] = React.useState(null);
    const [labelModal, setLabelModal] = React.useState("");
    const [sizeModal, setSizeModal] = React.useState("md");

    const toggleModalItems = () => {
        setModalState(!modalState);

    };

      const obtenerComprobanteAimprimir = async (idComprobante) => {
        let paramsPrint = {
          id_comprobantes: idComprobante
        }
        let response = await comprobantesPrintData(paramsPrint)
        return response;
      };

    const columns = [
        { field: 'id', headerName: 'ID', flex: 1,},
        { field: 'fecha', headerName: 'Fecha', flex: 1, },
        {
            field: "actions",
            headerName: "Acciones",
            type: "actions",
            flex: 1,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={
                        <Tooltip title="Impresion">
                            <span>
                                <LocalPrintshopIcon color="info" />
                            </span>
                        </Tooltip>
                    }
                    onClick={async () => {
                        setSizeModal('xl');
                        let contenidoChild = await obtenerComprobanteAimprimir(params.id);
                        setChildModal(<ComprobantePrint contenidoChild={contenidoChild} />)
                        setLabelModal("Impresion de Comprobante")
                        setModalState(true);
                    }}
                    label="Impresion"
                />,
            ]
        }];

    return (
        <Box sx={{ height: 400, width: '100%' }}>
            {modalState && (
                <SimpleDialogComponent
                    open={modalState}
                    modalName={labelModal}
                    child={childModal}
                    handleClose={toggleModalItems}
                    buttonEnviar={false}
                    buttonCancelar={true}
                    maxWidth={sizeModal}
                />
            )}
            <DataGrid
                rows={data.map((item, index) => ({ ...item, id: item.id || index }))}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5, 10]}
                localeText={esES.components.MuiDataGrid.defaultProps.localeText} // hace que la cabecera de los filtros este español
            />
        </Box>
    );
};

export default ComprobantesTable;